import { render } from "./AccountOnHold.vue?vue&type=template&id=d56ae3fe"
import script from "./AccountOnHold.vue?vue&type=script&lang=js"
export * from "./AccountOnHold.vue?vue&type=script&lang=js"

import "./AccountOnHold.vue?vue&type=style&index=0&id=d56ae3fe&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\php\\Resturant-POS-PHP-VUE-MODULE\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__